import { getCareersPage, getGlobals } from "storyblok/api"
import Meta from "components/Meta"
import CareersPage from "components/DynamicComponent/organisms/CareersPage"

export default function Careers({ meta, story }) {


  return (
    <>
     <Meta info={meta} />
    <CareersPage story={story}  />
    </>
  )
}

export async function getStaticProps({ preview = null}) {
  const globals = await getGlobals() ?? null 
  const story = await getCareersPage(preview) ?? null

  return {
    props: {
      story: story ?? null,
      meta: story?.page?.content?.twentysixty_seo ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}
